var BottomSheetDefaultText = {
  logoUrl: 'https://gos3.ibcdn.com/use-app-1638775723.png',
  heading: 'Want an extra 20% off?',
  description: 'Download the Goibibo app and use code ONAPP to get an extra 20% off on this booking.',
  ctaText: 'DOWNLOAD AND SAVE MORE',
  continueText: 'Continue on mobile site'
};
var TopBannerDefaultText = {
  heading: 'Save more on APP!!',
  subHeading: 'Get INR 1700 DISCOUNT* only on our APP. Use Code: GOAPP',
  logoUrl: 'https://gos3.ibcdn.com/top-bar-mweb2app-1659001525.gif',
  ctaTextInstall: 'OPEN',
  ctaTextOpen: 'OPEN',
  bgColor: '#FFC24A',
  ctaBgColor: '#ffffff',
  ctaTextColor: '#F16736',
  ctaBorderColor: 'transparent',
  headingTextColor: '#46484d',
  fallbackHeading: 'Save more on APP!!',
  fallbackSubHeading: 'Get INR 1700 DISCOUNT* only on our APP. Use Code: GOAPP',
  src: '',
  dest: '',
  fullWidthCtaBtnText: 'Get App',
  showFullBtnInTopNav: false,
  fullBtnCtaTextOpen: 'Open App Now',
  fullBtnCtaTextInstall: 'Get App Now',
  fullBtnCtaTextColor: '#3393FE',
  fullBtnCtaBgColor: '#ffffff',
  subHeadingWithTimer: 'Get INR 100 worth goCash by logging in App.'
};
var DesktopDrawerDefaultText = {
  logoUrl: 'https://gos3.ibcdn.com/use-app-1638775723.png',
  heading: 'Download App',
  description: 'Download app to get exclusive offers',
  ctaText: 'Download App',
  bgColor: '#fff',
  ctaTextColor: '#000'
};
var InlineCardBannerDefaultText = {
  logoUrl: 'https://gos3.ibcdn.com/offers-1646300530.png',
  heading: 'Save up to Rs.450 extra in app',
  codeLabel: '',
  code: '',
  codeColor: '',
  cardHeight: ''
};
var InlineCardBannerDesktopDefaultText = {
  logoUrl: 'https://gos3.ibcdn.com/gi-app-1660799492.png',
  heading: 'Exclusive offers on the app!',
  description: 'Download the Goibibo app and save more'
};
var FullPageDefaultText = {
  logoUrl: 'https://gos3.ibcdn.com/offers-1647417147.png',
  heading: 'Want an extra 20% off?',
  description: 'Download the Goibibo app and get an extra 20% off on this booking.',
  ctaText: 'DOWNLOAD AND SAVE MORE',
  continueText: 'Continue to mobile site'
};
var MwebRecentSearchCardText = {
  ctaText: 'Download the App now',
  ctaTextColor: '#2276e3',
  logoUrl: 'https://gos3.ibcdn.com/recentSearchAppBanner-1649056608.svg'
};
var DwebRecentSearchCardText = {
  heading: 'Upto ₹1700&#42; Off',
  description: 'Valid only on app',
  qrLabel: 'Scan to download'
};
var BottomBarDefaultText = {
  ctaText: 'Manage Booking via App',
  ctaTextColor: '#fff',
  backgroundColor: '#FF6D38'
};
var DesktopSidePopupDefaultText = {
  qrheading: 'Scan to download App',
  qrheadingtextcolor: '#000000',
  heading: 'Save upto ₹1700* on APP. Use code: GOAPP',
  headingtextcolor: '#FFFFFF',
  headingbgcolor: '#141823',
  qrLogoUrl: 'https://gos3.ibcdn.com/dweb2app-qr-logo-1664447597.png',
  qrImageUrl: ''
};
var FloatingBarDefaultText = {
  ctaBgColor: 'rgb(255, 109, 56)',
  ctaTextColor: '#FFFFFF',
  ctaBorderColor: 'rgb(255, 109, 56)',
  ctaText: 'Open In App'
};

export { BottomBarDefaultText as B, DesktopDrawerDefaultText as D, FloatingBarDefaultText as F, InlineCardBannerDefaultText as I, MwebRecentSearchCardText as M, TopBannerDefaultText as T, BottomSheetDefaultText as a, FullPageDefaultText as b, DesktopSidePopupDefaultText as c, InlineCardBannerDesktopDefaultText as d, DwebRecentSearchCardText as e };
